<script setup lang="ts">
import { LucideCheckCircle, LucideArrowLeft } from 'lucide-vue-next'
import { Button } from '~/components/ui/button'
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'

const { t } = useI18n()
const breadcrumbs = computed(() => [
  { title: t('page.register.breadcrumbs'), url: '/register' },
  { title: t('page.register.success.breadcrumbs'), url: '/register/success' }
])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />

      <div class="flex min-h-[60vh] items-center justify-center">
        <div class="mx-auto max-w-xl text-center">
          <div class="rounded-2xl bg-white p-8 shadow-xl">
            <div
              class="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-100"
            >
              <LucideCheckCircle class="h-8 w-8 text-green-600" />
            </div>

            <Heading tag="h1" class="mb-4 text-2xl font-bold text-gray-900">
              {{ $t('page.register.success.title') }}
            </Heading>

            <div class="mb-8 space-y-2">
              <p class="font-semibold text-gray-700">
                {{ $t('page.register.success.message') }}
              </p>
              <p class="text-sm text-gray-500">
                {{ $t('page.register.success.note') }}
              </p>
            </div>

            <Button variant="outline-blue" as-child>
              <NuxtLinkLocale to="/" class="flex items-center justify-center gap-2">
                <LucideArrowLeft class="h-4 w-4" />
                {{ $t('page.register.success.home') }}
              </NuxtLinkLocale>
            </Button>
          </div>
        </div>
      </div>
    </Container>
  </Main>
</template>
